import { useAuthAxios } from '@/backend/utils';

const http = useAuthAxios();
const prefix = '/api/v2/advances';
export const advanceGet = (path, params) => http.get(prefix + path, { params }).then(r => r.data);
export const advancePost = (path, payload, options = {}) => http.post(prefix + path, payload, options).then(r => r.data);
export const saveAdvanceSettings = payload => http.put(prefix + '/settings', payload).then(r => r.data);
